import styled from 'styled-components';

export default styled.div`
  padding: 0 13px;
  padding-top: 40px;
`;
